import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import * as Actions from './redux-actions.js'
import * as helpers from './helpers.js'
import * as globals from './globals.js'

import { useHistory } from "react-router-dom";


import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import TopNav from './TopNav.jsx'

import CreateUser from './CreateUser.jsx'
import Bookings from './Bookings.jsx'
import Transfers from './Transfers.jsx'
import Prices from './Prices.jsx'
import Simcards from './Simcards.jsx'


export const AdminItems = [
  {name: "bookings", text: "Bookings", component: <Bookings />},
  {name: "transfers", text: "Transfers", component: <Transfers />},
  {name: "users",    text: "Users",    component: <CreateUser />}
]

export const DictionaryItems = [
  {name: "prices",    text: "Prices",    component: <Prices />},
  {name: "simcards",    text: "Simcards",    component: <Simcards />}
]

const useStyles = makeStyles(theme => ({
  list: {
    width: 250,
    margin: "1rem",
  },
  fullList: {
    width: 'auto',
  },
}));



function AdminPage(props) {
  const classes = useStyles()
  const authenticated = useSelector(state => state.authenticated)
  const current_user = useSelector(state => state.current_user)
  const dispatch = useDispatch()
  const serverStatus = useSelector(state => state.serverStatus)
  const [drowerState, setDrowerState] = useState(false)
  const history = useHistory();

  const openDrower = () => {
    setDrowerState(true)
  }

  const closeDrower = () => {
    setDrowerState(false)
  }


  let fcomp
  let comp
  let currItem
  let currItemTitel
  if (props.match) { 
     let fcomp = AdminItems.find((f)=>f.name===props.match.params.page) ||
                 DictionaryItems.find((f)=>f.name===props.match.params.page) 
     
     if (fcomp) {
        comp = fcomp.component
        currItem = fcomp.name
        currItemTitel = fcomp.text
     } else {
        comp = null
     }
  }



  let ListAdminItems = AdminItems.map((i) => {
     return (<ListItem button selected={currItem === i.name} onClick={() => { history.push("/"+i.name); closeDrower()} }>
                <ListItemText primary={i.text} />
             </ListItem>)
  })

  let ListDictionaryItems = DictionaryItems.map((i) => {
     return (<ListItem button selected={currItem === i.name} onClick={() => { history.push("/"+i.name); closeDrower()} }>
                <ListItemText primary={i.text} />
             </ListItem>)
  })


  return (
   <div className={classes.offset}>
    <TopNav onClick={openDrower} caption={currItemTitel}/>
    
    <Drawer anchor="left" open={drowerState} onClose={closeDrower}>
     <div className={classes.list}>
      <List>
         {ListAdminItems}
      </List>
      <Divider />
      <List>
        {ListDictionaryItems}
      </List>
    </div>

    </Drawer>

     <div className="section">
     
     { comp }
     
    </div>

</div>
  )

}

export default AdminPage